import { z } from 'zod';

const publicEnvironmentSchema = z.object({
  VITE_EXPERIMENTAL_ENGLISH: z.enum(['true', 'false']).optional().default('false'),
});

export function parsePublicConfig(environment: unknown) {
  const parsed = publicEnvironmentSchema.parse(environment);
  return {
    experimentalEnglish: parsed.VITE_EXPERIMENTAL_ENGLISH === 'true',
  } as const;
}

export const publicConfig = parsePublicConfig(import.meta.env);
